import React from 'react';
import { Navigate, useSearchParams } from 'react-router-dom';

/**
 * Query keys that used to deep-link into the submissions queue at `/forms`.
 * Those URLs now belong on `/approvals`; bare `/forms` is the new Forms hub.
 */
const APPROVALS_QUERY_KEYS = [
  'formId',
  'status',
  'foremanArea',
  'foremanAreaId',
  'serviceAreaId',
] as const;

export const LegacyFormsToApprovals: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [searchParams] = useSearchParams();
  const shouldRedirect = APPROVALS_QUERY_KEYS.some((key) => searchParams.has(key));

  if (shouldRedirect) {
    const query = searchParams.toString();
    return <Navigate to={query ? `/approvals?${query}` : '/approvals'} replace />;
  }

  return <>{children}</>;
};
